// Food menu
/*!
 * Highlight buttons/selections on click, multi views inside modals and moving between, ...
 */

$(document).ready(function () {
  // Handle clicks on buttons within a .selectable container
  $("#food-menu").on("click", ".selectable .btn", function () {
    var $this = $(this);
    var $container = $this.closest(".selectable");

    var isOptional = $container.hasClass("selectable-optional");
    var isMulti = $container.hasClass("selectable-multi");

    if (isMulti) {
      if (isOptional) {
        // .selectable.selectable-multi.selectable-optional
        // Toggle freely with no restrictions
        $this.toggleClass("selected");
      } else {
        // .selectable.selectable-multi
        // Toggle, but ensure at least one remains selected
        if ($container.find(".selected").length > 1 || !$this.hasClass("selected")) {
          $this.toggleClass("selected");
        }
      }
    } else if (isOptional) {
      // .selectable.selectable-optional
      // Toggle the selection, allow for none selected but not multiple
      if ($this.hasClass("selected")) {
        $this.removeClass("selected");
      } else {
        $container.find(".btn").removeClass("selected");
        $this.addClass("selected");
      }
    } else {
      // .selectable (only)
      // Single select with exactly one button always selected
      if (!$this.hasClass("selected")) {
        $container.find(".btn").removeClass("selected");
        $this.addClass("selected");
      }
    }
  });

  // Tabs
  $("#food-menu").on("click", "[id^=obrokZavihki] .nav-item a", function (event) {
    event.preventDefault();
    $(this).tab("show");
  });

  // Switch to first tab (home) and close modal
  $("#food-menu").on("click", ".btn-modal-close", function (event) {
    event.preventDefault();
    var $modal = $(this).closest(".modal");
    $modal.find("[id^=obrokZavihki] .nav-link:first").tab("show");
    $modal.modal("hide");
    $modal.find(".form-notice").addClass("d-none");
    $modal.find(".btn-description").removeClass("d-none");
    $modal.find(".obrok-preklic-tab .btn-modal-close").addClass("d-none");
    $modal.find(".btn-cancel-confirm").removeClass("d-none");
    $modal.find(".simple-header").removeClass("d-none");
  });

  // Switch to first tab (home)
  $("#food-menu").on("click", ".btn-modal-home, .btn-tab-home", function (event) {
    event.preventDefault();
    var $modal = $(this).closest(".modal");
    $modal.find('[id^="obrokZavihki"] .nav-link').first().tab("show");
  });

  // Button for opening the second tab
  $("#food-menu").on("click", ".btn-tab-priloga", function () {
    var $modal = $(this).closest(".modal");
    $modal.find('a[id^="prilogaZavihek"]').tab("show");
  });

  // Button for opening the third tab
  $("#food-menu").on("click", ".btn-tab-dodatek", function () {
    var $modal = $(this).closest(".modal");
    $modal.find('a[id^="dodatekZavihek"]').tab("show");
  });

  $("#food-menu").on("click", ".btn-tab-hranila", function () {
    var $modal = $(this).closest(".modal");
    $modal.find('a[id^="podrobnejeZavihek"]').tab("show");
  });

  $("#food-menu").on("click", ".btn-tab-alergeni", function () {
    var $modal = $(this).closest(".modal");
    $modal.find('a[id^="alergeniZavihek"]').tab("show");
  });

  $("#food-menu").on("click", ".btn-tab-preklici", function () {
    var $modal = $(this).closest(".modal");
    $modal.find('a[id^="preklicZavihek"]').tab("show");
  });

  $("#food-menu").on("shown.bs.tab", ".modal a.nav-link", function (e) {
    var tabId = (e.target && e.target.id) || "";
    var $modal = $(e.target).closest(".modal");

    // choose your rule:
    // only home visible:
    var showMainChrome = /^oJediZavihek/.test(tabId);

    // OR home + priloga visible:
    // var showMainChrome = /^(oJediZavihek|prilogaZavihek)/.test(tabId);

    $modal.find(".modal-header, .modal-footer").toggleClass("d-none", !showMainChrome);
  });

  // Deselect all
  // Handle clicks on the .btn-deselect-all button within modals
  $("#food-menu").on("click", ".btn-deselect-all", function () {
    var $this = $(this);
    var $currentTab = $this.closest(".tab-pane"); // Find the closest tab-pane containing the button

    // Deselect all selected buttons within this specific tab only
    $currentTab.find(".btn.selected").removeClass("selected");
  });

  // Highlight meal selection
  // When a div that triggers a modal is clicked
  $("#food-menu").on("click", '[data-toggle="modal"]', function () {
    var openerKey = $(this).data("opener"); // Get the data-opener value of the div
    var targetModal = $(this).data("target"); // Get the target modal
    $(targetModal).data("opener", openerKey); // Store the opener data in the modal's data
  });

  window.modalClose = function (context) {
    var $currentModal = $(context).closest(".modal");
    $currentModal.modal("hide");
  };

  //
  // --------------------------------------------------------------------------------
  // Show #shfts connected to the location
  //

  // Parse URL to get date parameter and select the corresponding .cal-day
  window.selectDayFromDateParameter = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var dateParam = urlParams.get("date"); // Assume URL parameter is named 'date'

    if (dateParam) {
      var formattedDate = dateParam.replace(/-/g, "."); // Replace '-' with '.'
      var matchingDay = $('.cal-day[data-date="' + formattedDate + '"]');
      if (matchingDay.length && !matchingDay.hasClass("disabled")) {
        matchingDay.click(); // Simulate click to select and trigger related actions
      }
    }
  };

  // Handling clicks on calendar days
  $(document).on("click", ".cal-day:not(.disabled)", function () {
    $(".cal-day").removeClass("selected");
    $(this).addClass("selected");
    $("#select-location").removeClass("d-none");
    resetSelections();

    var $this = $(this);
    var $month = $this.data("month");
    $("#food-menu #cal-title .this-month").text($month);

    // Check for preselected locations and display shifts
    autoSelectPreselectedLocation();
    autoSelectPreselectedShift();
  });

  // Function to display shifts for a given location
  window.displayLocationShifts = function (locationButton) {
    let locationName = locationButton.attr("name");
    $("#select-shift").removeClass("d-none");
    $(".location-shifts").addClass("d-none");
    var targetShifts = $("#" + locationName);
    targetShifts.removeClass("d-none");

    // Check if the visible location-shifts has no children buttons
    if (targetShifts.children(".btn-shift").length === 0) {
      $(".notification-shifts-empty").removeClass("d-none"); // Show notification if no shifts
    } else {
      $(".notification-shifts-empty").addClass("d-none"); // Hide notification if shifts are present
    }
  };

  // Handling clicks on location buttons
  // $('#food-menu .btn-location').click(function() {
  $(document).on("click", "#food-menu .btn-location", function () {
    if (!$(this).hasClass("selected")) {
      $("#dataLabel").empty();
      $("#mealsWraper").empty();
      $("#select-shift .btn").removeClass("selected");
      $("#select-meal-type").addClass("d-none");
    }

    $(".btn-location").removeClass("selected");
    $(this).addClass("selected");

    displayLocationShifts($(this));
    autoSelectPreselectedShift();
  });

  // Handling clicks on shift buttons
  $(document).on("click", ".btn-shift", function () {
    $(".btn-shift").removeClass("selected");
    $(this).addClass("selected");
    $("#select-meal").removeClass("d-none");
    $("#select-meal-type").addClass("d-none");
  });

  // Resets all selections on calendar change
  function resetSelections() {
    $(".btn-location").removeClass("selected");
    $(".btn-shift").removeClass("selected");
    $("#select-shift").addClass("d-none");
    $(".location-shifts").addClass("d-none");
    $("#select-meal").addClass("d-none");
    $(".notification-shifts-empty").addClass("d-none");
    $("#select-meal-type").addClass("d-none");
  }

  function getAutoSelectCandidate($buttons, preselectedClass) {
    var $preselectedButton = $buttons.filter("." + preselectedClass).first();
    if ($preselectedButton.length) {
      return $preselectedButton;
    }

    if ($buttons.length === 1) {
      return $buttons.first();
    }

    return $();
  }

  // Function to automatically select preselected location if present
  window.autoSelectPreselectedLocation = function () {
    var $locationButtons = $("#locations .btn-location:not(.d-none):not(:disabled)");
    var $locationCandidate = getAutoSelectCandidate($locationButtons, "preselected-location");

    if ($locationCandidate.length) {
      $(".btn-location").removeClass("selected");
      $locationCandidate.addClass("selected");
      displayLocationShifts($locationCandidate);
    } else {
      // If no preselected location, clear all and hide shifts section
      resetSelections();
    }
  };

  // Function to automatically select preselected shift if present
  window.autoSelectPreselectedShift = function () {
    var $shiftButtons = $(".location-shifts:not(.d-none) .btn-shift:not(.d-none):not(:disabled)");
    var $shiftCandidate = getAutoSelectCandidate($shiftButtons, "preselected-shift");

    if (!$shiftCandidate.length || $shiftCandidate.hasClass("selected")) {
      return; // don't reset location/day here
    }

    setTimeout(function () {
      $shiftCandidate.trigger("click");
    }, 0);
  };

  // Select the day based on URL parameter on page load
  // selectDayFromDateParameter();  Moved to food-menu.jsp

  //
  // --------------------------------------------------------------------------------
  // Calendar days carousel on mobile screens
  //

  // Filter meals based on selected meal type
  window.applyMealFilter = function () {
    var activeId = $('#meal-type input[type="radio"]:checked').attr("id");
    var targetType = activeId === "tople-malice" ? "hot-meal" : "cold-meal";

    $("#meals .meal").each(function () {
      var $meal = $(this);
      $meal.toggleClass("d-none", $meal.data("meal-type") !== targetType);
    });
  };

  var startIndex = 0; // Start showing from the first cal-day

  window.updateWeekVisibility = function () {
    if ($(window).width() < 992) {
      var $calDays = $(".cal-day");
      $calDays.hide(); // Hide all days initially
      $calDays.slice(startIndex, startIndex + 7).fadeIn(); // Only show a slice of 7 days

      // Update button visibility
      $("#previousWeek").toggleClass("d-none", startIndex === 0);
      $("#nextWeek").toggleClass("d-none", startIndex + 7 >= $calDays.length);
    }
  };

  // Button click handlers
  $("#nextWeek").click(function () {
    startIndex += 7;
    updateWeekVisibility();
  });

  $("#previousWeek").click(function () {
    startIndex -= 7;
    if (startIndex < 0) startIndex = 0;
    updateWeekVisibility();
  });

  // Window resize event to reset startIndex on larger screens
  $(window).resize(function () {
    if ($(window).width() >= 992) {
      $(".cal-day").show(); // Show all on larger screens
      $("#nextWeek, #previousWeek").addClass("d-none"); // Hide navigation buttons
    } else {
      updateWeekVisibility(); // Adjust display for smaller screens
    }
  });

  // Initial visibility setup on page load for mobile navigation
  if ($(window).width() < 992) {
    updateWeekVisibility();
  }

  // End
});
